<div class="grid grid-nogutter flex justify-content-start align-items-center width-100 pl-3" style="gap: 10px">
  <app-thumbnail
    (click)="navigateTo(item)"
    [imgSrc]="item.user.avatar | mediaObject"
    [circle]="true"
    size="lg"
  ></app-thumbnail>
  <div class="col min-w-0">
    <a (click)="navigateTo(item)" class="block overflow-hidden white-space-nowrap text-overflow-ellipsis">
      {{ item.user.username }}
    </a>
    <small class="muted-text">{{ item.createdAt | date: 'medium' }}</small>
  </div>
</div>
